import * as React from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import { sortByName } from '../../../utils/sorting';
import { makeStyles } from '@material-ui/core/styles';
import { components } from 'react-select';
import { noOverflow } from '../../../themes/styles';
import { CustomTooltip } from '../../BuildingBlocks/Tooltip/Tooltip';
import StyledSelect from '../../BuildingBlocks/Select/StyledSelect';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  root: {
    backgroundColor: theme.palette.brand.white,
  },
  image: {
    marginLeft: theme.spacing(1),
    position: 'absolute',
    height: theme.spacing(2.5),
    width: theme.spacing(2.5),
    left: 0,
  },
  customOptionText: {
    paddingLeft: theme.spacing(3),
    display: 'inline-block',
    cursor: 'default',
    maxWidth: '100%',
    ...(noOverflow as object),
  },
}));

export default function FilterProduct({ onChange, lineOnEditMode }) {
  const classes = useStyles();
  const { products } = useLinesContext();

  let productList =
    products &&
    sortByName(products).map((product, i) => ({
      value: product.name,
      label: product.name,
      image: product.image,
      id: product.id,
    }));

  productList?.unshift({
    value: 'All products',
    label: 'All products',
  });
  const customOption = (props) => {
    const { data } = props;

    return (
      <CustomTooltip
        arrow
        placement="right"
        enterDelay={500}
        enterNextDelay={500}
        title={<Typography>{data.value}</Typography>}
      >
        <div>
          <components.Option {...props}>
            {data.image !== undefined && (
              <Avatar src={data.image} className={classes.image}>
                {!data.image && (
                  <Typography>
                    {data.value?.slice(0, 1)?.toUpperCase()}
                  </Typography>
                )}
              </Avatar>
            )}
            <span className={classes.customOptionText}>{data.value}</span>
          </components.Option>
        </div>
      </CustomTooltip>
    );
  };

  return (
    <StyledSelect
      className={classes.root}
      defaultValue={'All products'}
      onChange={(e) => {
        if (e.value === 'All products') {
          onChange(null);
        } else {
          onChange(e.id);
        }
      }}
      CustomOption={customOption}
      dropDownIconPath={'icons/arrowMenuOpener.svg'}
      options={productList}
      disable={lineOnEditMode}
    />
  );
}
